import React from 'react';
import { Switch } from 'react-router';

import { createTheme, ThemeProvider } from '@mui/material';

import PageRoute from 'main/components/PageRoute';

import Changelog from './sections/Docs/Changelog';
import ChangelogDetails from './sections/Docs/ChangelogDetails';
import Home from './sections/Docs/Home';

const Docs: React.FC = () => {
    return (
        <ThemeProvider theme={(theme) => createTheme(theme, { mode: 'light' })}>
            <Switch>
                <PageRoute
                    exact
                    path="/"
                    component={Home}
                    title="Docs"
                    description="Documentation for the Vulners API"
                />
                <PageRoute
                    exact
                    path="/changelog"
                    component={Changelog}
                    title="Changelog"
                    description="Changelog for the Vulners API"
                />
                <PageRoute
                    path="/changelog/:id"
                    component={ChangelogDetails}
                    title="Changelog details"
                    description="Full changelog entry"
                />
            </Switch>
        </ThemeProvider>
    );
};

export default Docs;
